import qs from 'qs';
import axios from '@/plugins/axios';
import utils from '@/stores/utils';

const { loadFiltersFromStorage, saveFiltersToStorage } = utils;

const DEFAULT_FILTERS = { offset: 0, limit: 20 };

const createState = (options = {}) => ({
    billingaccounts: [],
    billingaccounts_count: 0,
    billingaccounts_loading: false,
    billingaccounts_loading_errors: null,
    billingaccounts_filters: DEFAULT_FILTERS,
    cancelTokenSource: null,
    _storageOptions: options || {},
});


const mutations = {

    updateBillingAccounts(state, billingaccounts) {
        state.billingaccounts = billingaccounts;
    },
    updateBillingAccountsCount(state, count) {
        state.billingaccounts_count = count;
    },
    updateBillingAccountsLoading(state, loading) {
        state.billingaccounts_loading = loading;
    },
    updateBillingAccountsLoadingErrors(state, errors) {
        state.billingaccounts_loading_errors = errors;
    },
    updateBillingAccountsFilters(state, filters) {
        state.billingaccounts_filters = filters;
        const { storageKey, fieldsToSave } = state._storageOptions;
        if (storageKey) {
            saveFiltersToStorage(storageKey, state.billingaccounts_filters, fieldsToSave);
        }
    },
    updateCancelTokenSource(state, source) {
        state.cancelTokenSource = source;
    },
    updateStorageOptions(state, storage_options) {
        state._storageOptions = storage_options;
    },
};


const actions = {

    async setBillingAccountAsDefault({ commit, dispatch, state, rootGetters }) {
        if (rootGetters['session/current_user_permissions'].indexOf("billing.change_billingaccount") === -1) {
            return;
        }

        const url = `/api/billingaccounts/${state.billingaccount.id}/default/`;
        try {
            const response = await axios.post(url);
            dispatch('fetchBillingAccount');
            return response;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            throw error;
        }
    },

    async fetchBillingAccounts({ commit, state, rootGetters }) {
        if (rootGetters['session/current_user_permissions'].indexOf("billing.view_billingaccount") === -1) {
            return;
        }

        // Cancel any pending request
        if (state.cancelTokenSource) {
            state.cancelTokenSource.cancel("New fetch started");
        }

        // Create new cancel token source
        const source = axios.CancelToken.source();
        commit('updateCancelTokenSource', source);

        commit('updateBillingAccountsLoading', true);
        commit('updateBillingAccountsLoadingErrors', null);

        try {
            const response = await axios.get('/api/billingaccounts/', {
                params: state.billingaccounts_filters,
                cancelToken: source.token,
            });
            commit('updateBillingAccountsLoading', false);
            commit('updateBillingAccounts', response.data.results);
            commit('updateBillingAccountsCount', response.data.count);
            return response.data;
        } catch (xhr_error) {
            // Ignore cancelled requests
            if (axios.isCancel(xhr_error)) {
                return;
            }
            const error = utils.handleError(xhr_error);
            commit('updateBillingAccountsLoadingErrors', error.details);
            commit('updateBillingAccountsLoading', false);
            throw error;
        }
    },

    async init({ commit, state, rootGetters }, params) {
        // Update storage options if provided
        if (params.storageOptions !== undefined) {
            await commit('updateStorageOptions', params.storageOptions);
        }
        
        // Load filters from localStorage if storage is configured
        await commit('updateBillingAccountsFilters', { 
            ...DEFAULT_FILTERS, 
            ...(state._storageOptions?.storageKey ? loadFiltersFromStorage(state._storageOptions?.storageKey, {}) : {}),
            ...(params.filters || {})
        });
    },

};

export default (options = {}) => ({
    namespaced: true,
    state: createState(options),
    mutations,
    actions
});